var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasonry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 231,
    viewBox: "0 0 320 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_2245)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.846,
    height: 231,
    rx: 8.88461,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.346,
    y: 17.7693,
    width: 104.838,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6621,
    y: 44.4231,
    width: 79.9615,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6621,
    y: 58.6384,
    width: 44.4231,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.203,
    y: 35.5386,
    width: 27.5423,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.741,
    cy: 39.9809,
    r: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.492,
    y: 91.5115,
    width: 53.3077,
    height: 62.1923,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 160,
    width: 54,
    height: 78,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4922,
    y: 193.512,
    width: 53.3077,
    height: 62.1923,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2148,
    y: 91.5115,
    width: 53.3077,
    height: 62.1923,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 160,
    width: 54,
    height: 75,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 92,
    width: 53,
    height: 96,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 139,
    width: 53,
    height: 96,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 92,
    width: 53,
    height: 72,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 169,
    width: 53,
    height: 72,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.131,
    y: 91.5115,
    width: 53.3077,
    height: 42.19,
    rx: 3.55385,
    fill: "#DBDBDB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.444231,
    y: 0.444231,
    width: 318.958,
    height: 230.112,
    rx: 8.44038,
    stroke: "#DBDBDB",
    strokeWidth: 0.888462
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_2245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.846,
    height: 231,
    rx: 8.88461,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonry);
export default __webpack_public_path__ + "static/media/masonry.24eba6f2905d541fec2bf75a0d4505de.svg";
export { ForwardRef as ReactComponent };